import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const GearRatioCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-gear-ratio-calculator" />;

export default GearRatioCalculatorGuidePage;
